// src/axiosInstance.js
import axios from "axios";
import { API_URL } from "@/config";

const axiosInstance = axios.create({
	baseURL: API_URL,
	headers: {
		"Content-type": "application/json",
	},
	withCredentials: true,
});

// Response interceptor per gestire errori di autenticazione
axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		// Gestione 401: sessione scaduta
		if (error.response?.status === 401) {
			// Ignora 401 da /auth/me (è la chiamata del router guard per verificare l'autenticazione)
			const requestUrl = error.config?.url || "";
			if (requestUrl.includes("/auth/me")) {
				return Promise.reject(error);
			}

			// Importa setAuth dal router per invalidare la cache
			import("@/router").then(({ setAuth }) => {
				setAuth(false);
			});

			// Salva URL corrente per tornare dopo il login
			const returnTo = window.location.pathname + window.location.search;

			// Evita loop se siamo già sul login
			if (!window.location.pathname.includes("/auth")) {
				console.warn("Sessione scaduta. Redirect al login...");
				window.location.href = `/auth?returnTo=${encodeURIComponent(returnTo)}`;
			}
		}

		return Promise.reject(error);
	},
);

export default axiosInstance;
